export const SessionKeys = {
	SESSION_USER_TOKEN: `${window['appSettings'].env}-user-token`,
	SESSION_IS_REFRESHING: `${window['appSettings'].env}-user-token-refreshing`,
	IMPERSONATION_COOKIE: `${window['appSettings'].env}-mynha-impersonation`,
	USER_PROFILE: 'user-profile'
};
